import { createBrowserHistory } from 'history';

export default createBrowserHistory();



// WEBPACK FOOTER //
// ./src/common/utils/history.js